import { cn } from '@/shared/lib/utils'
import { FLOW_STATUS_STYLES, NO_ACTIVE_FLOW_LABEL } from '../consts/portal-flow-labels'

interface PortalStatusBadgeProps {
  /** Estado del flujo activo, o null si no hay flujo. */
  status: string | null | undefined
  className?: string
}

/** Badge del estado del flujo del portal para la tabla de Clientes. */
export function PortalStatusBadge({ status, className }: PortalStatusBadgeProps) {
  const style = status ? FLOW_STATUS_STYLES[status] : undefined

  if (!style) {
    return (
      <span
        className={cn(
          'inline-flex w-fit items-center rounded-lg border px-1.5 py-0.5 text-xs font-medium text-muted-foreground',
          className
        )}
      >
        {NO_ACTIVE_FLOW_LABEL}
      </span>
    )
  }

  return (
    <span
      className={cn(
        'inline-flex w-fit items-center rounded-lg border px-1.5 py-0.5 text-xs font-medium',
        style.className,
        className
      )}
    >
      {style.label}
    </span>
  )
}
